const enum TransactionType {
  Credit = 'credit',
  Debit = 'debit',
}

export default TransactionType;
